import { userConstants } from "../constants/userConstant";
export const userActions = {
    updateCurrentCustomer, requestCode, setServiceType, setCurrentUser
};
function updateCurrentCustomer(customer) {
    localStorage.setItem('currentUser', JSON.stringify(customer));
    return customdDispatch => {
        customdDispatch(updateCustomerDispatch(customer));
    };
}
function requestCode(mobile) {
    return { type: userConstants.REQUEST_CODE, currentMobile: mobile }
}
function setCurrentUser(currentUser) {
    var now = new Date();
    var time = now.getTime();
    var expireTime = time + 1000*3000;
    now.setTime(expireTime);
    document.cookie = 'au=ok;expires=' + now.toUTCString() + ';path=/';
    localStorage.setItem('currentUser', JSON.stringify(currentUser));
    return { type: userConstants.SET_CURRENT_USER, currentUser: currentUser }
}

function setServiceType(serviceTypeId) {
    return { type: userConstants.SET_SERVICETYPE, currentServiceTypeId: serviceTypeId }
}
function updateCustomerDispatch(customer) { return { type: userConstants.SET_CURRENT_CUSTOMER, customer: customer } }